import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationRecentsEmptyStateMobile(props) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h96v28.704H47.844V12L12 48l35.844 36V67.305H96V96H0V0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IllustrationRecentsEmptyStateMobile;
